import Select, { createFilter } from 'react-select'
import CompanyShortOptions from '../Components/PhotoOptions/CompanyShortOptions'
import {
  filterNewApprovalPhotos,
  filterNewGalleryPhotos,
  getMultiObjectFromValue,
  getMultiValueFromObject
} from '../Functions'
import update from 'immutability-helper'
import React from 'react'

const CompaniesSearch = ({
  state,
  setState,
  varNames
}) => {
  const { [`${varNames.companies}`]: companies } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-companies'>
      <Select
        isMulti
        isClearable
        className='photos-search-container'
        options={CompanyShortOptions}
        placeholder='Select companies...'
        onChange={(companies) => {
          callbacks[`${varNames.callback}`]({
            state: update(state, {
              [`${varNames.companies}`]: { $set: getMultiValueFromObject(companies) }
            }),
            setState: (state) => setState(state),
            varNames
          })
        }}
        value={getMultiObjectFromValue(companies, CompanyShortOptions)}
        filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
      />
    </div>
  )
}

export default CompaniesSearch
